module.exports = __webpack_public_path__ + "media/1.bca5b4a9.mp3";